import { Navigate, Outlet } from 'react-router-dom';
import { useConvexAuth } from 'convex/react';
import { AppScrollContainerSync } from '../components/AppScrollContainerSync';
import { Navigation } from '../components/Navigation';

export function AppLayout() {
  const { isAuthenticated, isLoading } = useConvexAuth();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden">
      <AppScrollContainerSync />
      <Navigation />
      <main className="app-scroll-container bg-background min-h-0 w-full min-w-0 flex-1 overflow-x-hidden overflow-y-auto">
        <div className="bg-background min-h-full w-full flex-1">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
